import { render } from "./GetExif.vue?vue&type=template&id=19d51bda"
import script from "./GetExif.vue?vue&type=script&lang=js"
export * from "./GetExif.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Samples\\学习\\WebPackTest\\my-diary\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__